import { PropsWithChildren } from "react";

import Button, { ButtonSize, buttonTheme } from "@components/button/button";
import { TopicflowIconMap } from "@components/topicflow-icon/topicflow-icon";

type Props = {
  title: string;
  small?: boolean;
  backUrl?: string;
};

const Heading: React.FC<PropsWithChildren<Props>> = ({
  title,
  children,
  small = false,
  backUrl,
}) => {
  return (
    <div className="flex items-center gap-2">
      {backUrl && (
        <Button
          theme={buttonTheme.iconGray}
          icon={TopicflowIconMap.arrowLeft}
          size={ButtonSize.medium}
          to={backUrl}
        />
      )}
      {small ? (
        <h2 className="text-2xl font-medium text-gray-800">{title}</h2>
      ) : (
        <header className="pb-4 sm:pb-6">
          <h1 className="capitalize text-3xl font-bold text-gray-800">
            {title}
          </h1>
          {children}
        </header>
      )}
    </div>
  );
};

export default Heading;
